<template>
  <div class="content">
    <textarea
      name=""
      id=""
      cols="30"
      rows="10"
      placeholder="编辑你的帖子内容..."
      v-model="title"
    ></textarea>

    <div class="add-img">
      <uploader
        upload-icon="plus"
        v-model="fileList"
        :after-read="afterRead"
        :max-count="9"
        preview-size="2.1rem"
      >
        <!-- <div class="add">
          <i class="iconfont icon-jia"></i>
        </div>
        <template #preview-cover="{ file }">
          <div class="preview-cover van-ellipsis">{{ file.name }}</div>
        </template> -->
      </uploader>
    </div>

    <div class="fb-btn" @click="submit">发布</div>
  </div>
</template>

<script>
/**
@description:编辑社区
@createTime:2021-08-26
@create:wq
*/
import { Uploader } from "vant";

import { uploadimg } from "../../utils/tool";
export default {
  name: "",
  props: {},
  components: { Uploader },
  data() {
    return {
      fileList: [],
      title: "",
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {},
  methods: {
    async afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      // 此时可以自行将文件上传至服务器
      const imgurl = await uploadimg(file);
      console.log(imgurl);
      if (imgurl) {
        file.status = "";
        file.message = "";
        file.imgurl = imgurl;
      } else {
        file.status = "failed";
        file.message = "上传失败";
      }
    },
    submit() {
      const imgurl = this.fileList.map((o) => o.imgurl.complete_url);
      this.api
        .community({ title: this.title, thumb: JSON.stringify(imgurl) })
        .then(() => {
          this.Toast.success("发布成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 2000);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  margin: 0 0.24rem;
  overflow: hidden;
}
textarea {
  font-size: 0.3rem;
  border: none;
  width: 100%;
  margin-top: 0.4rem;
  resize: none;
}
// .add {
//   width: 2.3rem;
//   height: 2.3rem;
//   background: #f5f5f5;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   i {
//     color: #cccccc;
//     font-size: 1rem;
//   }
// }
// .preview-cover {
//   width: 2.3rem;
//   height: 2.3rem;
// }
.van-uploader__preview {
  margin: 0 2px 2px 0 !important;
}
.fb-btn {
  background: #4fd9d5;
  border-radius: 0.4rem;
  height: 0.8rem;

  font-size: 0.28rem;
  font-weight: 500;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.4rem;
  box-shadow: 0 3px 6px rgba($color: #4fd9d5, $alpha: 0.3);
}
</style>
